import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './ui/UI';
import { DecryptedText } from './animations/DecryptedText';
import { TiltedCard } from './animations/TiltedCard';
import { RadarEcho } from './animations/RadarEcho';
const acronyms = ['ASV', 'AEV', 'BAS', 'CEM', 'CTEM', 'EASM', 'Attack-path validation'];
const timeline = [{
  year: '2004',
  title: 'Periscan founded',
  desc: 'Built on the premise of continuous assessment.'
}, {
  year: '2005',
  title: "Hacker's-eye view",
  desc: 'Service launched to test networks constantly.'
}, {
  year: 'Acquired',
  title: 'Catbird Networks',
  desc: 'The original company was acquired.'
}, {
  year: '2026',
  title: 'Reborn',
  desc: 'Rebuilt by the same founder for the AI era.'
}];
export function WhyNow() {
  return <section id="brand-legacy" aria-labelledby="legacy-heading" className="relative w-full py-32 border-t border-white/5 overflow-hidden" data-id="element-1515">
      {/* Continuous radar sweep — reinforces the "hacker's-eye view"
              heritage described in the copy. Subtle: sits behind content, low
              opacity, slower sweep than FinalCTA for a more contemplative feel. */}
      <RadarEcho intensity={0.4} sweepDuration={14} ringDuration={7} rings={4} data-id="element-1516" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1517">
        <SectionLabel number="—" label="Brand Legacy · Since 2004" className="mb-8" data-id="element-1518" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20" data-id="element-1519">
          <div className="lg:col-span-7" data-id="element-1520">
            <motion.h2 id="legacy-heading" initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6
          }} className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold tracking-[-0.02em] leading-[1.05] text-white" data-id="element-1521">
              Periscan is not new.
              <br data-id="element-1522" />
              <span className="text-white/40" data-id="element-1523">It's back.</span>
            </motion.h2>
          </div>
          <div className="lg:col-span-5 lg:pt-4 space-y-6" data-id="element-1524">
            <p className="text-lg text-white/75 leading-relaxed" data-id="element-1525">
              Founded in 2004 by Sean Heiney, Periscan was built around a simple
              idea: security assessment should be continuous.
            </p>
            <p className="text-lg text-white/75 leading-relaxed" data-id="element-1526">
              By 2005, the original Periscan described its service as working
              constantly to give customers a hacker's-eye view of their network.
              That was before the market had acronyms for everything.
            </p>

            <div className="py-4 border-y border-white/10 flex flex-wrap gap-x-4 gap-y-2 font-mono text-xs text-[#1a8fd4] uppercase tracking-widest" data-id="element-1527">
              {acronyms.map((acronym, i) => <Fragment key={acronym} data-id="element-1528">
                  <span className="inline-block" data-id="element-1529">
                    <DecryptedText text={acronym} speed={30} animateOn="view" data-id="element-1530" />
                  </span>
                  {i < acronyms.length - 1 && <span className="text-white/20" data-id="element-1531">·</span>}
                </Fragment>)}
            </div>

            <p className="text-lg text-white/75 leading-relaxed" data-id="element-1532">
              The original company was acquired by Catbird Networks. Now
              Periscan is being rebuilt by the same founder for the AI era.
            </p>

            <p className="text-2xl text-white font-medium tracking-tight pt-4" data-id="element-1533">
              The mission did not change. The surface did.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1534">
          {timeline.map((item, i) => <motion.div key={item.year} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} data-id="element-1535">
              <TiltedCard maxTilt={5} scale={1.02} className="h-full p-6 rounded-xl bg-[#070a0e] border border-white/[0.06] hover:border-[#1a8fd4]/30 transition-colors" data-id="element-1536">
                <div className="font-mono text-sm text-[#1a8fd4] mb-4" data-id="element-1537">
                  {item.year}
                </div>
                <h3 className="text-lg font-semibold text-white tracking-tight mb-2" data-id="element-1538">
                  {item.title}
                </h3>
                <p className="text-sm text-white/60 leading-relaxed" data-id="element-1539">
                  {item.desc}
                </p>
              </TiltedCard>
            </motion.div>)}
        </div>
      </div>
    </section>;
}